import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import ProcessButton from '../buttons/ProcessButton';

const section4Str = "Your data is never sold to third parties.\nHit.Movie does not serve ads.\nYou can delete your data anytime.";

export default function StepOne(props) {
    
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faAddressCard} style={{ color: props.yellowColor, fontSize: 30, marginTop: 30 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        margin: 30 }}>
            <div style={{ fontSize: 18, fontFamily: 'OpenSans-SemiBold', color: props.yellowColor }}>
                IDENTITY VERIFICATION
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: props.whiteColor, marginTop: 12, textAlign: 'center' }}>
                Hit Movie is a 'Premier Show Platform (PSP)' exclusively for 'identity-verified-users'.
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: props.whiteColor, marginTop: 12, textAlign: 'center' }}>
                Verification is a one-time process and takes about 2 minutes. You will be asked to provide the following
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: props.whiteColor, marginTop: 12 }}>
                <ul>
                <li>Govt. ID with Photo - Front</li>
                <li>Govt. ID with Photo - Back</li>
                <li>A Video Selfie</li>
                </ul>
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: props.yellowColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center' }}>
                {section4Str}
            </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 16 }}>
            <ProcessButton text="Start Verification" bgColor={props.yellowColor}
            onClick={()=>{props.startVerification()}} />
            <div onClick={()=> window.open("https://docs.hit.movie/identity-verification", "_blank")} style={{ position: 'absolute', marginLeft: 220, marginTop: 10, cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faQuestionCircle} style={{ color: props.yellowColor, fontSize: 20 }} />
            </div>
        </div>
      </div>
    );
}